module.exports = __webpack_public_path__ + "static/media/new-logo.2fec2102.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/new-logo.png
// module id = 362
// module chunks = 37